'use client';

const defaultProps = {
  variant: "default"
};
export {
  defaultProps
};
